import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
const bonusFeatures = ['10 almuerzos de rescate en 15 min', '5 cenas anti-quejas familiares', '5 postres rápidos sin lío', 'Checklist "10 básicos Rescate"', 'Rotación semanal rápida', 'Versión imprimible A4', 'Formato PDF mobile-first'];
export function BonusSection() {
  return <section className="w-full py-10 md:py-12 px-6 bg-gradient-to-b from-rose-50 to-rose-100/50" data-id="element-9">
      <div className="max-w-3xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="relative bg-gradient-to-br from-rose-50 to-rose-100/50 rounded-3xl p-6 md:p-10 shadow-warm-lg border border-rose-200/40" data-id="element-11">
          {/* Bonus ribbon */}
          <div className="absolute -top-4 -right-4 md:top-6 md:right-6" data-id="element-12">
            <motion.div initial={{
            scale: 0,
            rotate: -12
          }} whileInView={{
            scale: 1,
            rotate: 12
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3,
            type: 'spring'
          }} className="flex items-center gap-2 px-4 py-2 bg-amber text-white font-bold text-sm rounded-full shadow-lg" data-id="element-13">
              <GiftIcon className="w-4 h-4" data-id="element-14" />
              ¡GRATIS!
            </motion.div>
          </div>

          <span className="inline-block px-4 py-2 mb-4 text-sm font-semibold text-amber-dark bg-amber/20 rounded-full" data-id="element-15">
            📙 BONO EXCLUSIVO
          </span>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brown-dark mb-2" data-id="element-16">
            Recetas Rescate EXTRA
          </h2>

          <p className="font-heading text-lg md:text-xl text-amber-dark font-medium mb-6" data-id="element-17">
            20 Recetas en 15 Min (10 Almuerzos + 5 Cenas + 5 Postres)
          </p>

          {/* Bonus Image */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="mb-6 -mx-2" data-id="element-18">
            <img src="https://cdn.magicpatterns.com/uploads/9dwzdoY3gEWFPQm3bbNvF5/mama_expres_foto_3.png" alt="Mamá cocinando feliz mientras consulta recetas en su celular" className="w-full rounded-2xl object-cover aspect-[16/9]" data-id="element-19" />
          </motion.div>

          <div className="space-y-3" data-id="element-20">
            {bonusFeatures.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.08
          }} className="flex items-center gap-4" data-id="element-21">
                <div className="flex-shrink-0 w-7 h-7 bg-green rounded-full flex items-center justify-center" data-id="element-22">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-23" />
                </div>
                <p className="font-body text-brown-dark text-lg" data-id="element-24">{feature}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}